var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "w-dialog",
    {
      staticClass: "pop-dialog",
      attrs: {
        closeFree: "",
        width: "564px",
        title: "查看全部",
        top: "calc(50vh - 200px)",
      },
      on: {
        ok: function ($event) {
          _vm.visible = false
        },
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "user-content" },
        _vm._l(_vm.list, function (user, index) {
          return _c("div", { key: index, staticClass: "item-user" }, [
            _c("div", { staticClass: "user-photo" }, [
              _c("img", {
                staticClass: "avatar",
                attrs: {
                  src: require("@/assets/def_avatar_84px.png"),
                  alt: "",
                },
              }),
            ]),
            _c("div", { staticClass: "name-con" }, [
              _c("div", { staticClass: "serial" }, [
                _vm._v(_vm._s(user.serial)),
              ]),
              _c("div", { staticClass: "name ellipsis" }, [
                _vm._v(_vm._s(user.name || user.reallyName)),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }